


















































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import TabComponent from "@/components/layout/TabComponent.vue";
import SensorInfoComponent from "@/components/pages/sensors/SensorInfoComponent.vue";
import FurnitureInfoComponent from "@/components/pages/sensors/FurnitureInfoComponent.vue";
import WarningStopTimeInfoComponent from "@/components/pages/sensors/WarningStopTimeInfoComponent.vue";
import UserInfoComponent from "@/components/pages/sensors/UserInfoComponent.vue";
import SensorDiagramsComponent from "@/components/pages/sensors/SensorDiagramsComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { storeMenus } from "@/config/store_menus";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import { GetStoreSensorsResponse } from "@/typescript/api_client/emesh_api/stores/types";
import { getMeasureTargetEquipments } from "../../typescript/api_client/emesh_api/stores/measure_target_equipments_api";
import { convertNullObject } from "@/typescript/lib/common/convert_null_object";

export { GetStoreSensorsResponse };

// 非表示センサを表示するためのAPIパラメータ値
const SHOW_HIDDEN_SENSOR: number = 1;

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    TabComponent,
    SensorInfoComponent,
    FurnitureInfoComponent,
    WarningStopTimeInfoComponent,
    UserInfoComponent,
    SensorDiagramsComponent,
    FooterComponent
  }
})
export default class SensorsShowPage extends Vue {
  storeSensors: GetStoreSensorsResponse | any = {};
  furnitures: any[] = [];

  sensorInfoTab: string = "センサ情報";
  furnitureInfoTab: string = "什器情報";
  userInfoTab: string = "ユーザー情報";
  sensorDiagramsTab: string = "センサ配置図";
  warningStopTimesTab: string = "警報停止時間帯";

  tabs: { name: string }[] = [
    { name: this.sensorInfoTab },
    { name: this.furnitureInfoTab },
    { name: this.userInfoTab },
    { name: this.sensorDiagramsTab },
    { name: this.warningStopTimesTab }
  ];
  activeTabName: string = this.sensorInfoTab;

  setActiveTabName(tabName: string): void {
    this.activeTabName = tabName;
  }

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "SensorsShowPage")?.id
    });

    if (
      this.tabs.find(m => m.name === this.$store.state.sensorsTabName)?.name !==
      undefined
    )
      this.activeTabName = this.$store.state.sensorsTabName;

    this.$store.commit("setSensorsTabName", {
      sensorsTabName: null
    });
  }

  async setApiData() {
    const storeId = this.$route.params["store_id"];
    const storeSensors = await getStoreSensorsApi(storeId, SHOW_HIDDEN_SENSOR);
    storeSensors.sensors.map(ss => {
      return convertNullObject(ss, "--", [
        "equipment_name",
        "equipmentkind_name",
        "guard_time",
        "lower_limit",
        "model_id",
        "model_name",
        "upper_limit"
      ]);
    });
    storeSensors.sensors.sort(
      (a, b) => Number(a.location_no) - Number(b.location_no)
    );
    this.storeSensors = storeSensors;
    const measureTargetEquipments = await getMeasureTargetEquipments();
    // 什器とセンサを紐付ける
    this.furnitures = measureTargetEquipments.map(mte => {
      const sensors = storeSensors.sensors.filter(
        s =>
          s.measure_target_equipment_kind_id ===
          mte.measure_target_equipment_kind_id
      );
      const serialNo = storeSensors.sensors.find(
        s =>
          s.measure_target_equipment_kind_id ===
          mte.measure_target_equipment_kind_id
      )?.measure_target_serial_no;
      return {
        measure_target_equipment_kind_name:
          mte.measure_target_equipment_kind_name,
        measure_target_serial_no: serialNo,
        sensors: sensors
      };
    });
    // センサが紐付いていない什器を取り除く
    this.furnitures = this.furnitures.filter(f => {
      return f.sensors.length >= 1;
    });
  }

  mounted() {
    this.setApiData();
  }
}
